import { usePasswordField } from "@/react/hooks/usePasswordField";
import { PASSWORD_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { PasswordStrengthIndicator } from "@circle-react/components/shared/PasswordField/PasswordStrengthIndicator";
import { PasswordVisibilityToggle } from "@circle-react/components/shared/PasswordField/PasswordVisibilityToggle";
import { CheckoutFormField } from "../../../CheckoutFormField";

export const CheckoutFormPasswordField = () => {
  const {
    isPasswordVisible,
    setIsPasswordVisible,
    passwordValue,
    passwordFieldError,
    passwordStrength,
    handleBlur,
  } = usePasswordField({ fieldName: "password" });

  return (
    <CheckoutForm.Item name="password">
      <div className="relative flex items-center">
        <CheckoutFormField
          type={isPasswordVisible && passwordValue ? "text" : "password"}
          name="password"
          options={{
            required: true,
            pattern: PASSWORD_REGEX,
          }}
          className="w-full"
          onBlur={handleBlur}
        />
        <PasswordVisibilityToggle
          passwordValue={passwordValue}
          isPasswordVisible={isPasswordVisible}
          setIsPasswordVisible={setIsPasswordVisible}
        />
      </div>
      <PasswordStrengthIndicator
        passwordStrength={passwordStrength}
        passwordFieldError={passwordFieldError}
        passwordValue={passwordValue}
      />
    </CheckoutForm.Item>
  );
};
